import { render, staticRenderFns } from "./DialogAddEditSwapTournament.vue?vue&type=template&id=4e35f29b&scoped=true"
import script from "./DialogAddEditSwapTournament.js?vue&type=script&lang=js&external"
export * from "./DialogAddEditSwapTournament.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e35f29b",
  null
  
)

export default component.exports